export * from './dokumentum.service';
export * from './kar.service';
export * from './modozat.service';
export * from './szerzodes.service';
